import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';

class ManifestList extends Component {
  static defaultProps = {
    multiSelectable: true,
    isAdmin: false
  }
  static propTypes = {
    dataProvider: PropTypes.array.isRequired,
    deleteManifest: PropTypes.func.isRequired
  }

  render() {
    const { dataProvider, deleteManifest } = this.props;

    const content = dataProvider.map(item => {
      const { id, deliveryDate, driver, unit, container, stops } = item;
        return (<TableRow key={id}>
          <TableRowColumn>{moment(deliveryDate).format('MM/DD/YYYY')}</TableRowColumn>
          <TableRowColumn>{_.get(driver, 'name', 'Unknown')}</TableRowColumn>
          <TableRowColumn>{_.get(unit, 'name', 'Unknown')}</TableRowColumn>
          <TableRowColumn>{_.get(container, 'name', '')}</TableRowColumn>
          <TableRowColumn>{stops.length || 0}</TableRowColumn>
          <TableRowColumn><IconButton iconClassName="material-icons" onClick={() => { deleteManifest(item) }}>delete</IconButton></TableRowColumn>
        </TableRow>);
      });

    return (
      <div>
        <Table multiSelectable={false} selectable={false}>
          <TableHeader>
            <TableRow>
              <TableHeaderColumn>Delivery Date</TableHeaderColumn>
              <TableHeaderColumn>Driver</TableHeaderColumn>
              <TableHeaderColumn>Unit</TableHeaderColumn>
              <TableHeaderColumn>Trailer</TableHeaderColumn>
              <TableHeaderColumn>Stops</TableHeaderColumn>
              <TableHeaderColumn />
            </TableRow>
          </TableHeader>
          <TableBody deselectOnClickaway={false}>
            { content }
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default ManifestList;


// WEBPACK FOOTER //
// ./src/components/Dispatcher/Manifests/List.js